import React, { ReactElement, useCallback, useMemo, useState } from "react"
import { BigNumber } from "@ethersproject/bignumber"
import SearchSelect from "./SearchSelect"
import { TOKENS_MAP, CRO } from "../constants"
import type { TokenOption } from "../pages/Swap"
import { Zero } from "@ethersproject/constants"
import classnames from "classnames"
import { commify } from "../utils"
// import { formatBNToString } from "../utils"
import styles from "./SwapInput.module.scss"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
// import Text from "./Text"
import { ChevronRight } from "@mui/icons-material"
import Modal from "./Modal"
import AmountInput from "./AmountInput"
import CroWarning from "./CroWarning"

interface Props {
  tokens: TokenOption[]
  selected: string
  inputValue: string
  inputValueUSD: BigNumber
  isSwapFrom: boolean
  onSelect?: (tokenSymbol: string) => void
  onChangeAmount?: (value: string) => void
}

export default function SwapInput({
  tokens,
  selected,
  onSelect,
  inputValue,
  // inputValueUSD,
  isSwapFrom,
  onChangeAmount,
}: Props): ReactElement {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const { t } = useTranslation()

  const handleSelect = useCallback(
    (value: string) => {
      onSelect?.(value)
      setIsDropdownOpen(false)
    },
    [onSelect],
  )
  const selectedToken = TOKENS_MAP[selected]

  const selectedTokenOption = useMemo(() => {
    return tokens.find(({ symbol }) => symbol === selectedToken?.symbol)
  }, [tokens, selectedToken])

  // const formattedBalance = commify(
  //   formatBNToString(
  //     selectedTokenOption?.amount || Zero,
  //     selectedTokenOption?.decimals || 0,
  //     selectedTokenOption?.decimals || 6,
  //   ),
  // )

  return (
    <Box className={styles.swapInputWrapper}>
      <Box className={styles.swapInputInnerWrapper}>
        <div
          className={classnames(
            styles.selectGroup,
            onSelect && styles.hoverPointer,
          )}
          onClick={() => onSelect && setIsDropdownOpen((prev) => !prev)}
          tabIndex={0}
          onKeyDown={(e) => {
            if (onSelect && (e.key === "Enter" || e.key === " ")) {
              setIsDropdownOpen((prev) => !prev)
            }
          }}
        >
          {selectedToken && (
            <img src={selectedToken.icon} style={{ marginRight: "8px" }} />
          )}
          <div className={styles.tokenNameContainer}>
            <div className={styles.symbolArrowContainer}>
              <span className={styles.textPurple}>
                {selectedToken ? selectedToken.symbol : t("chooseToken")}
              </span>
              &nbsp;
              {onSelect && <ChevronRight />}
            </div>
          </div>
        </div>
        <Box className={styles.inputGroup}>
          <AmountInput
            value={isSwapFrom ? inputValue : commify(inputValue)}
            onChange={onChangeAmount}
            showMax={isSwapFrom && onChangeAmount !== undefined}
            readOnly={!isSwapFrom}
            balance={selectedTokenOption?.amount || Zero}
            decimals={selectedTokenOption?.decimals || 18}
            hidePercentageButtons
          />
        </Box>
        {isDropdownOpen && (
          <Modal
            title={t("Select Token")}
            onClose={() => setIsDropdownOpen(false)}
            open
          >
            <SearchSelect tokensData={tokens} onSelect={handleSelect} />
          </Modal>
        )}
      </Box>
      {selectedToken && selectedToken.symbol === CRO.symbol && (
        <CroWarning
          content={
            isSwapFrom
              ? "CRO will be wrapped as WCRO before swapping."
              : "WCRO will be unwrapped as CRO after swapping."
          }
        />
      )}
    </Box>
  )
}
